import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDhlComponent } from './simple-icons-dhl.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDhlComponent ],
    exports:      [ SimpleIconsDhlComponent ],
    bootstrap:    []
})
export class SimpleIconsDhlModule {}
